import { Grid } from "@mui/material";
import toast from "react-hot-toast";
import { CustomButton } from "../../../../components/customButton/CustomButton";
import { RenderInputByTypeMobile } from "../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import { UPDATE_NUMERO_DOCUMENTO_PACIENTE } from "../../../../data/graphQL/mutations/SoporteHC/paciente";
import { useMutationHandler } from "../../hooks/useMutationHandler";

export default function CambiarDNIPacienteForm() {
    const inputFields = [
        {
            name: 'idPaciente',
            type: 'int',
            displayName: 'HC Paciente',
            size: 2,
            required: true,
            placeholder: 'Ingrese HC Paciente'
        },
        {
            name: 'numeroDocumento',
            type: 'string',
            displayName: 'N° Documento',
            size: 2,
            required: true,
            placeholder: 'Ingrese Documento'
        },
    ];

    const { values, handleChange, handleSubmit, loading } =
        useMutationHandler({
            initialValues: {
                idPaciente: '',
                numeroDocumento: '',
            },
            mutation: UPDATE_NUMERO_DOCUMENTO_PACIENTE,
            onSuccess: (data) => {
                if (data.updateNumeroDocumentoPaciente.error) {
                    toast.error(data.updateNumeroDocumentoPaciente.error);
                }

                if (data.updateNumeroDocumentoPaciente.success)
                    toast.success('El número de documento del paciente se actualizó correctamente.');
            }
        });

    return (
        <form onSubmit={(e) => handleSubmit(e)}>
            <Grid container spacing={2}>
                {inputFields.map(({ size, ...input }) => (
                    <Grid key={input.name} size={{ xs: 12, sm: (size || 12) }} className="form-field-wrapper">
                        <RenderInputByTypeMobile
                            input={input}
                            value={values[input.name]}
                            handleChange={handleChange}
                        />
                    </Grid>
                ))}
                <Grid size={3}>
                    <CustomButton
                        variant='outlined'
                        isLoading={loading}
                        onClick={handleSubmit}
                    >Aceptar</CustomButton>
                </Grid>
            </Grid>
            <button type="submit" hidden />
        </form>
    )
}
